
export const BAND1_PAY = 465;
export const BAND2_PAY = 515;
export const BAND3_PAY = 570;